import React, { useContext } from 'react'

import { AnimatedListItem, RadioButtonInput } from '@pb/components'
import cn from 'classnames'

import { RadioButtonListContext } from '../RadioButtonList'
import styles from './RadioButton.scss'
import { RadioButtonProps } from './types'

const RadioButton: React.FC<RadioButtonProps> = ({
  name,
  inputValue,
  required,
  error,
  children,
  className,
  Wrapper = AnimatedListItem,
  shouldHideRadioButtonIcon = false,
  onSelect = () => {},
  ...props
}) => {
  const { value, ...controllerProps } = useContext<any>(RadioButtonListContext)

  const isChecked = value === inputValue

  if (isChecked) {
    onSelect()
  }
  const key = `radio_button_${inputValue}`

  return (
    <Wrapper key={key} className={cn(styles.item, className)} {...props}>
      <RadioButtonInput
        id={key}
        error={error}
        name={name}
        required={required}
        className={cn(
          styles.radioInputWrapper,
          styles.overrideBackgroundColor,
          styles.radioButtonPlacement,
        )}
        inputValue={inputValue}
        label={children}
        checked={isChecked}
        shouldHideRadioButtonIcon={shouldHideRadioButtonIcon}
        shouldDisableValidation
        shouldCenterRadioButtonInput={false}
        {...controllerProps}
      />
    </Wrapper>
  )
}

export default RadioButton
